import React, { useState, useRef, useEffect } from 'react';

const Select = ({ children, value, onValueChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState('bottom');
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    const updateDropdownPosition = () => {
      if (selectRef.current) {
        const rect = selectRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const spaceAbove = rect.top;
        const dropdownHeight = 200; 
        
        if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
          setDropdownPosition('top');
        } else {
          setDropdownPosition('bottom');
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', updateDropdownPosition);
    window.addEventListener('resize', updateDropdownPosition);

    if (isOpen) {
      updateDropdownPosition();
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', updateDropdownPosition);
      window.removeEventListener('resize', updateDropdownPosition);
    };
  }, [isOpen]);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleItemClick = (val) => {
    onValueChange(val);
    setIsOpen(false);
  };

  const selectedText = React.Children.toArray(children)
    .find(child => child.type.displayName === 'SelectContent')
    ?.props.children
    .find(child => child.props.value === value)
    ?.props.children || value;

  return (
    <div className="relative" ref={selectRef}>
      <div onClick={toggleDropdown} className="cursor-pointer">
        {React.Children.map(children, child => {
          if (child.type.displayName === 'SelectTrigger') {
            return React.cloneElement(child, {}, 
              React.Children.map(child.props.children, triggerChild => {
                if (triggerChild.type.displayName === 'SelectValue') {
                  return React.cloneElement(triggerChild, {}, selectedText || triggerChild.props.placeholder);
                }
                return triggerChild;
              })
            );
          }
          return null;
        })}
      </div>
      {isOpen && (
        <div 
          className={`absolute z-10 w-full bg-white border rounded shadow-lg ${
            dropdownPosition === 'top' ? 'bottom-full mb-1' : 'top-full mt-1'
          }`}
        >
          {React.Children.map(children, (child) => {
            if (child.type.displayName === 'SelectContent') {
              return React.cloneElement(child, { onItemClick: handleItemClick });
            }
            return null;
          })}
        </div>
      )}
    </div>
  );
};

Select.displayName = 'Select';
export default Select;